import React from 'react';

import { useBreakpoint } from '$hooks/events';
import { Image } from '$partials/media';
import { Tag } from '$partials/ui';
import { formatPrice, formatTagBanner } from '$utilities/format';
import OffMarketBox from './off-market-box.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings').PropertyItem}
 */
const Property = (props) => {
    const {
        priceGbp,
        heading,
        propertyName,
        area,
        outwardCode,
        url,
        publicSellingStatus,
        statusTag,
        listingMedia,
        parentPageType,
        offMarket
    } = props;

    const breakpoint = useBreakpoint([ 'main', 'sm', 'md' ], 'main');
    const image = listingMedia?.[0]?.image;

    if (offMarket) {
        return <OffMarketBox {...props}/>;
    }
    return (
        <article className='px5 md-px6 pt5 pb5 md-pb8'>
            {parentPageType !== 'SoldPropertyListingPage' && (
                <div className='absolute top-0 mt5 z2'>
                    <Tag
                        bgColor={publicSellingStatus === 'Sold' ? 'white' : 'yellow'}
                        title={formatTagBanner(publicSellingStatus, statusTag)}/>
                </div>
            )}
            <div style={{fontSize: '377px'}}>
                <div style={{
                    height: breakpoint === 'md' ? '377px' : 'auto',
                    width: breakpoint === 'md' ? `${(image?.width / image?.height)}em` : '280px',
                    maxWidth: '100%'
                }}>
                    {image && <Image {...image}/>}
                </div>
            </div>
            <div className='flex flex-col md-flex-row col-12 black pt5 md-pt8'>
                <div className='md-col-4 pr6 flex-col'>
                    {publicSellingStatus === 'Sold' && (
                        <p className='type-style-5'>Asking price:</p>
                    )}
                    <p className='type-style-5 pb3'>
                        {formatPrice(priceGbp)}
                    </p>

                    <div className='hide md-show'>
                        <p className='type-style-5'>{propertyName}</p>
                        <p className='type-style-5'>{area}{' '}{outwardCode}</p>
                    </div>
                </div>
                <div className='md-col-8 pr10 flex-grow'>
                    <h3 className='type-style-3'>{heading}</h3>
                </div>
                <div className='md-hide pt5'>
                    <p className='type-style-5'>{propertyName}</p>
                    <p className='type-style-5'>{area}{' '}{outwardCode}</p>
                </div>
            </div>
            <a
                className='link-reset expand-interaction__action'
                href={url}>
            </a>
        </article>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

Property.__typename = 'PropertyPage';

export default Property;
